document.addEventListener("DOMContentLoaded", function () {
  const passwordInput = document.querySelector(".show_password_input");
  const toggleButton = document.querySelector(".show_password");

  if(passwordInput  && toggleButton)
  {
    toggleButton.addEventListener("click", function () {
        const isPassword = passwordInput.getAttribute("type") === "password";
        passwordInput.setAttribute("type", isPassword ? "text" : "password");
    });
  }
});
document.addEventListener("DOMContentLoaded", function() {
  var params = new URLSearchParams(window.location.search);
  var targetId = params.get("goto");
  if (targetId) {
    var targetElem = document.getElementById(targetId);
    if (targetElem) {
      setTimeout(function() {
        // Calculate the offset position
        var headerOffset = 100; // height in px of your sticky header + extra margin
        var elementPosition = targetElem.getBoundingClientRect().top;
        var offsetPosition = elementPosition + window.scrollY - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }, 100);
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  function magnificationPopup(){
    const popup = document.getElementById("custom-popup");
    const trigger = document.getElementById("popup-trigger");
    const closeBtn = document.getElementById("popup-close");
    if(trigger)
    {
      // Open popup
      trigger.addEventListener("click", () => {
        popup.style.display = "flex";
        document.body.style.overflow = "hidden";
      });

      // Close popup
      closeBtn.addEventListener("click", () => {
        popup.style.display = "none";
        document.body.style.overflow = "";
      });

      // Close on overlay click
      popup.addEventListener("click", (e) => {
        if (e.target === popup) {
          popup.style.display = "none";
          document.body.style.overflow = "";
        }
      });

      // Close on ESC key
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          popup.style.display = "none";
          document.body.style.overflow = "";
        }
      });
    }
    let showBtn = document.querySelector(".popup-show-age");
    let hideBtn = document.querySelector(".popup-hide-age");
    let ageSection = document.querySelector(".magnification-by-age");
    let buttonsSection = document.querySelector(".magnification-buttons");

    if (showBtn && hideBtn && ageSection && buttonsSection) {
      // Show age chart
      showBtn.addEventListener("click", function() {
        ageSection.classList.remove("hidden");
        buttonsSection.classList.add("hidden");
      });

      // Hide age chart (go back)
      hideBtn.addEventListener("click", function() {
        ageSection.classList.add("hidden");
        buttonsSection.classList.remove("hidden");
      });
    }
  }
  magnificationPopup();
  if (typeof subscribe !== "undefined" && typeof PUB_SUB_EVENTS !== "undefined") {
    subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, (eventData) => {
      //console.log("Variant changed:", eventData);
      // const selectedOptions = eventData.data.selectedOptionValues;
        //console.log("Selected options:", selectedOptions);
      setTimeout(function(){
        magnificationPopup();
      }, 1000);
    });
  }
});

document.querySelectorAll('a[href^="http"]').forEach(link => {
  if (!link.href.includes(window.location.hostname)) {
    link.setAttribute('target', '_blank');
    link.setAttribute('rel', 'noopener noreferrer');
  }
});